export default [
  'timeminoutgoing',
  'timeminincoming',
  'timeminbusy',
  'timeminfree',
  'timemaxoutgoing',
  'timemaxincoming',
  'timemaxbusy',
  'timemaxfree',
  'thqueued',
  'name',
  'number',
  'userName',
  'department',
  'departmentName',
  'initials',
  'extension',
  'client',
  'call',
  'extStatus',
  'clientNo',
  'from',
  'departmentTo',
  'departmentFrom',
  'departmentIni',
  'input',
  'userFrom',
  'way',
  'channelIn',
  'channelOut',
  'status'
];
